import React from 'react';
import { PaymentOutlined, LocalGroceryStoreOutlined, QuestionAnswerOutlined, PeopleOutlined, CategoryOutlined, MessageOutlined, PhoneAndroid, BusinessOutlined, AnnouncementOutlined, QrCode } from '@material-ui/icons';

import LoginContainer from "container/LoginContainer.jsx";
import RegisterContainer from "container/RegisterContainer.jsx";
import RecoveryContainer from './container/RecoveryContainer';
import CategoryContainer from './container/CategoryContainer';
import UserContainer from './container/UserContainer';
import MessageContainer from './container/MessageContainer';
import CompanyContainer from './container/CompanyContainer';
import AnnouncementContainer from './container/AnnouncementContainer';
import PaymentContainer from './container/PaymentContainer';
import QrCodeContainer from './container/QrCodeContainer';
import PushScreen from './views/pages/Push/PushScreen';
import RefContainer from './container/RefContainer';
import TermsContainer from './container/TermsContainer';

export const loginRoute = "/auth/login";
export const registerRoute = "/auth/login";
export const homeRoute = "/admin/";

const routes = [
  {
  path: "/",
  name: "QR code",
  icon: "LocalGroceryStoreOutlinedIcon",
  iconComponent: <span class="material-icons">qr_code_2</span>,
  component: QrCodeContainer,
  layout: "/admin"
  },
  {
    path: "/push",
    name: "Push",
    icon: "people-outlined",
    iconComponent: <span class="material-icons">notifications_none</span>,
    component: PushScreen,
    layout: "/admin"
  },
  {
    path: "/refs",
    name: "Referências",
    icon: "insert_comment",
    iconComponent: <span class="material-icons-outlined">feed</span>,
    component: RefContainer,
    layout: "/admin"
  },
  {
    path: "/termos",
    name: "Termos",
    mini: "L",
    component: TermsContainer,
    layout: "/auth"
  },
  // {
  //   path: "/company",
  //   name: "Empresas",
  //   icon: "business-outlined",
  //   iconComponent: <BusinessOutlined />,
  //   component: CompanyContainer,
  //   layout: "/admin"
  // },
  // {
  //   path: "/category",
  //   name: "Categorias",
  //   icon: "CategoryOutlined",
  //   iconComponent: <CategoryOutlined />,
  //   component: CategoryContainer,
  //   layout: "/admin"
  // },
  // {
  //   path: "/payment",
  //   name: "Pagamentos",
  //   icon: "PaymentOutlined",
  //   iconComponent: <PaymentOutlined/>,
  //   component: PaymentContainer,
  //   layout: "/admin"
  //   },
  {
    path: "/login",
    name: "Login",
    mini: "L",
    component: LoginContainer,
    layout: "/auth"
  },
  // {
  //   path: "/recovery",
  //   name: "Recovery",
  //   mini: "L",
  //   component: RecoveryContainer,
  //   layout: "/auth"
  // },
  // {
  //   path: "/register",
  //   name: "Register",
  //   mini: "R",
  //   component: RegisterContainer,
  //   layout: "/auth"
  // },
];

export default routes;
